import { useParams , NotesComponent, EntityType } from '../../utils/globalImports';

const ProjectNotes: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <NotesComponent
      resourceId={Number(projectId)}
      title="Project"
      entityTypeId={EntityType.Project}
      entityId={Number(projectId)}
      searchbarText="Search for notes/comments"
    />
  );
};

export default ProjectNotes;
